import { z } from 'my-zod'

export const askPolarisCaseModel = z.object({
  caseNumber: z.string(),
  title: z.string(),
  createdOn: z.string(),
  modifiedOn: z.string(),
  stateCode: z.string(),
  statusCode: z.string(),
  supportArea: z.object({
    supportAreaName: z.string(),
    supportAreaId: z.string(),
    supportAreaCode: z.string()
  }),
  dealer: z.object({
    dealerName: z.string(),
    dealerNumber: z.string()
  }),
  responsibleContact: z.string(),
  vin: z.string(),
  authorizationStatus: z.string(),
  injuriesOccurred: z.string()
})

export type askPolarisCaseModel = z.infer<typeof askPolarisCaseModel>
